import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
export interface S3UploadInvoiceAttachResponse {
  processedFiles: string[];
  unProcessed: { fileName: string; errorMessage: string }[];
}
export interface S3UploadInvoiceAttachRequest {
  fileName: string;
  signedUrl: string;
  fileNameWithAttachId: string;
  attachId: number;
}
const useS3InvoiceAttach = (companyId: number, id?: number) => {
  const call = useCallback(
    async (params: S3UploadInvoiceAttachRequest[] = []) => {
      try {
        const response = await axiosInstance.post<S3UploadInvoiceAttachResponse>(
          api.uploadScanManagerInvoiceRecordFn(companyId, id),
          params
        );
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    [companyId, id]
  );
  const { execute, isLoading } = useAsync(call, false);
  return {
    S3InvoiceAttach: execute,
    isS3InvoiceFileAttaching: isLoading,
  };
};
export default useS3InvoiceAttach;
